import { AppShell, Center, Grid } from "@mantine/core";
import { UsersList } from "./UsersList";

export default function Users() {
  return <UsersList />;
}
